import { useTranslation } from 'react-i18next';
import toaster from 'src/utils/toaster';
import { useSaveQuotation } from './api';
import { isRecordedSource } from './config';
import {
	buildQuotationDraft,
	ensureQuotationCode,
	type PdfDataLike,
} from './snapshot';

export const useQuotationRecorder = () => {
	const { t } = useTranslation();
	const save = useSaveQuotation();

	const onError = (err: unknown) => {
		console.error('salvataggio preventivo fallito', err);
		toaster.error(
			t('quotation_save_error', {
				defaultValue:
					'Il PDF è stato generato, ma non è stato possibile salvarlo nello storico preventivi',
			})
		);
	};

	const record = (data: PdfDataLike, offer: unknown, services?: string) => {
		if (!isRecordedSource(data?.quotation?.source)) return;
		try {
			save.mutateAsync(buildQuotationDraft(data, offer, services)).catch(onError);
		} catch (err) {
			onError(err);
		}
	};

	return { ensureCode: ensureQuotationCode, record };
};
